import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import {
    CONTENT_CAP_PADDED,
    DetailTileCard,
    LoadMoreButton,
    SectionHead,
} from '~/ui-rocco/pages/detail-shared';
import { useSimilarProjects } from './use-similar-projects';

/**
 * More in {category} — the rest of the category, any practice, under the same
 * head the product page gives its category block.
 *
 * The heading this replaced set the category apart inline in a sentence; the
 * head states it as the section's subject instead, which is what it is.
 */
export const MoreInProjectCategorySection = () => {
    const { project } = useLoaderData<typeof loader>();
    // Four a row, so the trim keeps whole rows of four.
    const { tiles, hasMore, isLoading, loadMore } = useSimilarProjects(4);

    const categoryItem = project.Categories?.[0];
    const category = categoryItem?.PrettyTitle;

    if (!category || tiles.length === 0) return null;

    return (
        <section className="max-md:px-6 md:px-[3rem]">
            <div className={CONTENT_CAP_PADDED}>
                <SectionHead
                    tone="dark"
                    lead="More in"
                    subject={category}
                    subjectLink={categoryItem?.Link}
                    standfirst={`Everything else in ${category}, from every practice on ArchiPro.`}
                />

                <div className="grid grid-cols-2 max-md:mt-6 max-md:gap-x-3.5 max-md:gap-y-[3.6875rem] md:mt-[3.75rem] md:grid-cols-4 md:gap-x-3 md:gap-y-[6.25rem]">
                    {tiles.map((tile) => (
                        <DetailTileCard
                            key={tile.id}
                            tile={tile}
                            section="ProjectSimilar"
                            theme="dark"
                            mediaClassName="md:aspect-[37/27]"
                            textClassName="md:text-[1rem] md:leading-[1.3]"
                        />
                    ))}
                </div>

                {hasMore ? (
                    <LoadMoreButton
                        tone="dark"
                        className="max-md:mt-10 md:mt-[3.75rem]"
                        isLoading={isLoading}
                        onClick={loadMore}
                    />
                ) : null}
            </div>
        </section>
    );
};
